import { Svg } from './svg'

export const TableIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5C3.55228 5 4 4.55228 4 4C4 3.44772 3.55228 3 3 3Z"
      fill="currentColor"
    />
    <path
      d="M7 3C6.44772 3 6 3.44772 6 4C6 4.55228 6.44772 5 7 5H13C13.5523 5 14 4.55228 14 4C14 3.44772 13.5523 3 13 3H7Z"
      fill="currentColor"
    />
    <path
      d="M2 8C2 7.44772 2.44772 7 3 7C3.55228 7 4 7.44772 4 8C4 8.55228 3.55228 9 3 9C2.44772 9 2 8.55228 2 8Z"
      fill="currentColor"
    />
    <path
      d="M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13C3.55228 13 4 12.5523 4 12C4 11.4477 3.55228 11 3 11Z"
      fill="currentColor"
    />
    <path
      d="M6 8C6 7.44772 6.44772 7 7 7H13C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9H7C6.44772 9 6 8.55228 6 8Z"
      fill="currentColor"
    />
    <path
      d="M7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H13C13.5523 13 14 12.5523 14 12C14 11.4477 13.5523 11 13 11H7Z"
      fill="currentColor"
    />
  </Svg>
)
